/**
 * ApiKey_Service.ts
 * API key management  (sk-catalog-api /api/v1/api-keys)
 */

import axiosInstance from '../../api/axiosInstance';
import {
  Catalog_ApiKeys_Url,
  Catalog_ApiKey_Url,
  Catalog_ApiKey_Rotate_Url,
} from '../../api/endpoints';
import {
  CreateApiKeyPayload,
  ApiKeyResponse,
  ApiKeysResponse,
  CreateApiKeyResponse,
} from '../../schemas/catalog/apiKey';

/* ─────────────────────────────────────────
   List — GET /api/v1/api-keys
───────────────────────────────────────── */

export const getApiKeys = async (): Promise<ApiKeysResponse> => {
  const { data } = await axiosInstance.get<ApiKeysResponse>(Catalog_ApiKeys_Url);
  return data;
};

/* ─────────────────────────────────────────
   Get one — GET /api/v1/api-keys/:id
───────────────────────────────────────── */

export const getApiKey = async (id: string): Promise<ApiKeyResponse> => {
  const { data } = await axiosInstance.get<ApiKeyResponse>(Catalog_ApiKey_Url(id));
  return data;
};

/* ─────────────────────────────────────────
   Create — POST /api/v1/api-keys
   Returns the full secret once — store it; it is never shown again.
───────────────────────────────────────── */

export const createApiKey = async (payload: CreateApiKeyPayload): Promise<CreateApiKeyResponse> => {
  const { data } = await axiosInstance.post<CreateApiKeyResponse>(Catalog_ApiKeys_Url, payload);
  return data;
};

/* ─────────────────────────────────────────
   Rotate — POST /api/v1/api-keys/:id/rotate
   Invalidates the old secret and issues a new one atomically.
───────────────────────────────────────── */

export const rotateApiKey = async (id: string): Promise<CreateApiKeyResponse> => {
  const { data } = await axiosInstance.post<CreateApiKeyResponse>(Catalog_ApiKey_Rotate_Url(id));
  return data;
};

/* ─────────────────────────────────────────
   Revoke — DELETE /api/v1/api-keys/:id
───────────────────────────────────────── */

export const deleteApiKey = async (id: string): Promise<void> => {
  await axiosInstance.delete(Catalog_ApiKey_Url(id));
};
